const VERIFY_EMAIL_LOCALE_TEMPLATES = {
    "en": {
        "send.verify.success.message": "Email sent. Check your spam folder!",
        "send.verify.error.message": "Email not sent",
        "email.verification.screen.title": "Thanks for <br /> verifying!",
        "mobile.email.verification.screen.title": "Email <br /> verified",
        "email.verification.screen.login.button": "Login",
        "email.verification.screen.error.message": "Verify email failed",
    },
    "nl": {
        "send.verify.success.message": "E-mail verzonden. Controleer je spam-folder!",
        "send.verify.error.message": "E-mail niet verzonden",
        "email.verification.screen.title": "Bedankt voor <br /> het verifiëren!",
        "mobile.email.verification.screen.title": "Email <br /> bevestigd",
        "email.verification.screen.login.button": "Login",
        "email.verification.screen.error.message": "Verificatie e-mail mislukt",
    }
};

export default VERIFY_EMAIL_LOCALE_TEMPLATES;
